import { SummaryCard } from './index';

import { useTranslation } from 'react-i18next';
import { SummaryItemFormattedType, SummaryItemType } from '@type/dashboard';
import { divisionInfo } from '@utils/dashboard';

export const Summary = ({
  summaryList,
  isLoading,
}: {
  summaryList: SummaryItemType[];
  isLoading: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-grid grid-cols-sm-2 grid-cols-md-2 grid-cols-lg-4 grid-cols-xl-4 gap-10 mt-10 p-10 bg-light rounded border">
      {divisionInfo(t).map((item: SummaryItemFormattedType, index) => {
        const findData = summaryList.find(
          (nestedItem: SummaryItemType) =>
            nestedItem.division_id === item.divisionId,
        );

        return (
          <SummaryCard
            key={index}
            {...(item || {})}
            data={findData}
            isLoading={isLoading}
          />
        );
      })}
    </div>
  );
};
